<style scoped>
table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td.even {
    background-color: lightgray;
}

.monitoring-summary {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 12px 16px;
    background: #fafafa;
}

.monitoring-summary-item + .monitoring-summary-item {
    margin-top: 6px;
}

.monitoring-warehouse-select :deep(.vs__dropdown-toggle) {
    min-height: 42px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.monitoring-warehouse-select :deep(.vs__selected-options) {
    padding: 2px 6px;
}

.monitoring-warehouse-select :deep(.vs__search) {
    margin: 0;
}

.monitoring-lacak-sn ::v-deep table,
.monitoring-lacak-sn ::v-deep th,
.monitoring-lacak-sn ::v-deep td {
    border: none !important;
    border-collapse: separate;
}

.monitoring-lacak-sn ::v-deep td.even {
    background-color: inherit;
}

.monitoring-lacak-sn .lacak-sn-alert {
    height: auto !important;
    word-break: break-all;
}

.lacak-sn-modal ::v-deep .activity-timeline {
  margin-left: 0;
  padding-left: 0;
  border-left: none;
}
.lacak-sn-modal ::v-deep .activity-timeline > li {
  position: relative;
  margin-bottom: 0;
  min-height: 0;
  padding: 0 0 16px 28px;
}
.lacak-sn-modal ::v-deep .activity-timeline > li::before {
  content: "";
  position: absolute;
  left: 8px;
  top: 20px;
  bottom: -4px;
  width: 2px;
  background: #E5E8EB;
}
.lacak-sn-modal ::v-deep .activity-timeline > li:last-child::before {
  display: none;
}
.lacak-sn-modal ::v-deep .activity-timeline .timeline-icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border-radius: 50%;
  background: #CBD5E1;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}
.lacak-sn-modal ::v-deep .activity-timeline .timeline-icon.lacak-sn-timeline-icon--gi {
  background-color: #28c76f;
  color: #fff;
}
.lacak-sn-modal ::v-deep .activity-timeline > li.lacak-sn-timeline-item--latest .timeline-icon {
  background: #7367F0;
}
.lacak-sn-modal ::v-deep .activity-timeline > li.lacak-sn-timeline-item--latest .timeline-icon.lacak-sn-timeline-icon--gi {
  background-color: #28c76f;
}
.lacak-sn-modal ::v-deep .activity-timeline > li.lacak-sn-timeline-item--latest .activity-desc {
  font-weight: 600;
}
.lacak-sn-modal ::v-deep .activity-timeline .activity-desc {
  font-size: .9rem;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.lacak-sn-modal ::v-deep .activity-timeline .activity-e-time {
  font-size: .8rem;
  line-height: 1.4;
  margin-top: 2px;
  color: #64748b;
}
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Stock"></vs-tab>
                <vs-tab label="Daily"></vs-tab>
                <vs-tab label="Lacak SN"></vs-tab>
            </vs-tabs>

            <!-- Stock Tab -->
            <div v-if="activeTab === 0">
                <div class="flex flex-wrap items-center justify-between mb-4">
                    <div class="flex items-center ml-1">
                        <h4>Monitoring - Stock</h4>
                        <div style="margin-left: 10px">
                            <strong>Last updated at: {{ lastUpdated }}</strong>
                        </div>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh" :disabled="isLoading">Refresh</vs-button>
                        <vs-button @click="handleExport" class="btn mb-4 md:mb-0 mr-1" icon="import_export" :disabled="isExporting">Export</vs-button>
                    </div>
                </div>
                <div class="flex flex-wrap items-end -mx-2 mb-4">
                    <div class="w-full md:w-1/4 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Select Warehouse</label>
                        <v-select
                            :key="warehouseSelectKey"
                            ref="warehouseSelect"
                            class="monitoring-warehouse-select"
                            v-model="warehouse_ids"
                            :options="warehouses"
                            :reduce="(item) => item.id"
                            label="name"
                            multiple
                            placeholder="All Warehouses"
                            :close-on-select="false"
                        >
                            <template v-slot:search="{ attributes, events }">
                                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="warehouse_ids.length ? '' : 'All Warehouses'" />
                            </template>
                        </v-select>
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Start Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="start_date" />
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">End Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="end_date" />
                    </div>
                    <div class="w-full md:w-auto px-2">
                        <div class="flex flex-wrap mt-2">
                            <vs-button class="btn w-full md:w-auto mr-0 md:mr-1 mb-2 md:mb-0" icon="filter_list" @click="applyFilters">Filter</vs-button>
                            <vs-button class="btn w-full md:w-auto" color="warning" icon="refresh" @click="resetFilters">Reset</vs-button>
                        </div>
                    </div>
                </div>
                <div class="monitoring-summary mb-4">
                    <strong>Total Filtered Warehouses :</strong>
                    <div v-if="totalPerProduct.length" class="mt-2">
                        <div v-for="item in totalPerProduct" :key="item.product_code" class="monitoring-summary-item">
                            {{ item.product_code }} : {{ formatQty(item.total_inventory_qty) }}
                        </div>
                    </div>
                    <div v-else class="mt-2 text-muted">No data available</div>
                </div>
                <table class="table w-full border border-gray-300">
                    <thead>
                        <tr>
                            <th class="text-center" rowspan="2">Tanggal</th>
                            <th class="text-center" rowspan="2">Warehouse</th>
                            <th class="text-center" rowspan="2">Product Code</th>
                            <th class="text-center" rowspan="2">Description</th>
                            <th class="text-center" rowspan="2">Beginning QTY</th>
                            <th class="text-center" colspan="2">In QTY</th>
                            <th class="text-center" colspan="2">Out QTY</th>
                            <th class="text-center" rowspan="2">End QTY</th>
                        </tr>
                        <tr>
                            <th class="text-center">Inbound</th>
                            <th class="text-center">TWH In</th>
                            <th class="text-center">Outbound</th>
                            <th class="text-center">TWH Out</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(group, index) in tableData">
                            <tr :key="`index-${index}-${trIndex}`" v-for="(tr, trIndex) in group">
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''" :rowspan="group.length" v-if="trIndex == 0">{{ group[0].date }}</td>
                                <td class="text-center" :rowspan="group.length" :class="index % 2 === 0 ? 'even' : ''" v-if="trIndex == 0">{{ group[0].warehouse.name }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ tr.product.product_code }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ productDescription(tr.product) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.initial_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.twh_in_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.outbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.twh_out_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inventory_qty) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <vs-pagination class="mt-4" :total="totalPage" v-model="currentPage" @change="handleStockPageChange"></vs-pagination>

            </div>

            <!-- Daily Tab -->
            <div v-else-if="activeTab === 1">
                <div class="flex flex-wrap items-center justify-between mb-4">
                    <div class="flex items-center ml-1">
                        <h4>Daily Movement - All Warehouses</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="fetchMovement" class="btn mb-4 md:mb-0 mr-1" icon="refresh" :disabled="isLoading">Refresh</vs-button>
                        <vs-button @click="handleMovementExport" class="btn mb-4 md:mb-0 mr-1" icon="import_export" :disabled="isMovementExporting">Export</vs-button>
                    </div>
                </div>
                <div class="flex flex-wrap items-end -mx-2 mb-4">
                    <div class="w-full md:w-1/4 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Select Product</label>
                        <v-select
                            class="monitoring-warehouse-select"
                            v-model="movementProductCodes"
                            :options="movementProducts"
                            multiple
                            placeholder="All Products"
                            :close-on-select="false"
                        >
                            <template v-slot:search="{ attributes, events }">
                                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="movementProductCodes.length ? '' : 'All Products'" />
                            </template>
                        </v-select>
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Start Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="movementStartDate" />
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">End Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="movementEndDate" />
                    </div>
                    <div class="w-full md:w-auto px-2">
                        <div class="flex flex-wrap mt-2">
                            <vs-button class="btn w-full md:w-auto mr-0 md:mr-1 mb-2 md:mb-0" icon="filter_list" @click="applyMovementFilter">Filter</vs-button>
                            <vs-button class="btn w-full md:w-auto" color="warning" icon="refresh" @click="resetMovementFilter">Reset</vs-button>
                        </div>
                    </div>
                </div>
                <div class="monitoring-summary mb-4">
                    <strong>Total Accumulated :</strong>
                    <div v-if="movementTotalAccumulated.length" class="mt-2">
                        <div v-for="item in movementTotalAccumulated" :key="item.product_code" class="monitoring-summary-item">
                            {{ item.product_code }} : Total Inbound {{ formatQty(item.total_inbound_qty) }} | Total Outbound {{ formatQty(item.total_outbound_qty) }} | Sisa Stock : {{ formatQty(item.total_stock_qty) }}
                        </div>
                    </div>
                    <div v-else class="mt-2 text-muted">No data available</div>
                </div>
                <table class="table w-full border border-gray-300">
                    <thead>
                        <tr>
                            <th class="text-center">Tanggal</th>
                            <th class="text-center">Product Code</th>
                            <th class="text-center">Description</th>
                            <th class="text-center">Inbound</th>
                            <th class="text-center">Outbound</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(group, index) in movementData">
                            <tr :key="`movement-${index}-${trIndex}`" v-for="(tr, trIndex) in group">
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''" :rowspan="group.length" v-if="trIndex == 0">{{ group[0].date }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ tr.product_code }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ tr.description }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.outbound_qty) }}</td>
                            </tr>
                        </template>
                        <tr v-if="!movementData.length">
                            <td class="text-center" colspan="5">No data available</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-else-if="activeTab === 2" class="monitoring-lacak-sn">
                <h4 class="mb-4">Lacak Serial Number</h4>
                <p class="text-sm text-gray-600 mb-2">Masukkan SN (Pack ID), bisa lebih dari satu dipisah enter, koma, atau spasi. Maksimal 1000 SN.</p>
                <vs-textarea v-model="snInput" label="Serial Number" height="140px" class="w-full mb-2" />
                <p class="text-sm text-gray-600 mb-4">{{ snList.length }} SN</p>
                <div class="flex flex-wrap items-center mb-4">
                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-search" class="mr-2 mb-2" :disabled="!snList.length || snLoading" @click="searchSn">Lacak</vs-button>
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" class="mr-2 mb-2" :disabled="!snRows.length || snLoading" @click="exportMonitoringExcel">Export Excel</vs-button>
                    <vs-button color="dark" type="border" class="mb-2" :disabled="snLoading" @click="resetSn">Reset</vs-button>
                </div>
                <div v-if="snLoading" class="text-center py-8">Loading...</div>
                <template v-else-if="snSearched">
                    <vs-alert v-if="snNotFound.length" color="warning" active="true" class="mb-4 lacak-sn-alert">{{ snNotFound.length }} SN tidak ditemukan: {{ snNotFound.join(', ') }}</vs-alert>
                    <vs-table v-if="snRows.length" :data="snRows">
                        <template slot="thead">
                            <vs-th>No</vs-th>
                            <vs-th>Serial Number</vs-th>
                            <vs-th>Info Rute Gudang</vs-th>
                            <vs-th>Aksi</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <tr v-for="(row, index) in data" :key="row.sn">
                                <vs-td>{{ index + 1 }}</vs-td>
                                <vs-td>{{ row.sn }}</vs-td>
                                <vs-td>{{ row.route || '-' }}</vs-td>
                                <vs-td><vs-button size="small" @click="openSnDetail(row.sn)">Detail</vs-button></vs-td>
                            </tr>
                        </template>
                    </vs-table>
                    <div v-else class="text-center py-8">Tidak ada transaksi ditemukan.</div>
                </template>
                <vs-popup class="lacak-sn-modal" :active.sync="snDetailActive" :title="`Detail SN ${snDetailSn}`" v-if="snDetailSn">
                    <ul class="activity-timeline">
                        <li v-for="(tx, idx) in (snTxMap[snDetailSn] || [])" :key="tx.id" :class="{ 'lacak-sn-timeline-item--latest': idx === (snTxMap[snDetailSn] || []).length - 1 }">
                            <div class="timeline-icon" :class="{ 'lacak-sn-timeline-icon--gi': tx.transaction_type === 'GI' }">{{ tx.transaction_type === 'GI' ? '✓' : '•' }}</div>
                            <div class="activity-desc">{{ tx.warehouse_name }}<span v-if="tx.transaction_type === 'GI'"> (Sudah Good Issue)</span><span v-if="tx.reference"> — {{ tx.reference }}</span></div>
                            <div class="activity-e-time">{{ tx.posting_date }} · {{ tx.transaction_type }}<span v-if="idx === (snTxMap[snDetailSn] || []).length - 1"> · Posisi terakhir</span></div>
                        </li>
                    </ul>
                    <div v-if="!(snTxMap[snDetailSn] || []).length" class="text-center py-8">Tidak ada transaksi.</div>
                </vs-popup>
            </div>
        </vx-card>
    </div>
</template>

<script>
import FileSaver from 'file-saver'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'

export default {
    name: 'Monitoring',
    components: {
        flatPickr,
        vSelect,
    },
    data() {
        return {
            activeTab: 0,
            isLoading: false,
            isExporting: false,
            warehouse_ids: [],
            warehouseSelectKey: 0,
            start_date: '',
            end_date: '',
            warehouses: [],
            tableData: [],
            totalPerProduct: [],
            currentPage: 1,
            totalPage: 1,
            limit: 10,
            loadingCount: 0,
            lastUpdated: '-',
            stockLoadedPage: null,
            stockRequestInFlight: false,
            movementData: [],
            movementLoaded: false,
            isMovementExporting: false,
            movementProducts: [],
            movementProductCodes: [],
            movementTotalAccumulated: [],
            movementStartDate: '',
            movementEndDate: '',
            snInput: '',
            snRows: [],
            snNotFound: [],
            snSearched: false,
            snLoading: false,
            searchedSn: [],
            snTxMap: {},
            snDetailSn: '',
            snDetailActive: false,
        }
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        },
        activeTab(val) {
            if (val === 1 && !this.movementLoaded) {
                this.fetchMovement()
            }
        },
    },
    mounted() {
        this.fetchData()
    },
    computed: {
        snList() {
            return [...new Set(this.snInput.split(/[\s,;]+/).filter(Boolean))]
        },
    },
    methods: {
        async searchSn() {
            this.snLoading = true
            try {
                const response = await this.$http.post('support/lacak-sn', { sn: this.snList, include_gi: true })
                const bySn = new Map()
                ;(response.data.data || []).forEach((row) => {
                    if (!bySn.has(row.pack_id)) bySn.set(row.pack_id, [])
                    bySn.get(row.pack_id).push(row)
                })
                this.snTxMap = Object.fromEntries(bySn)
                this.searchedSn = [...this.snList]
                this.snRows = this.snList.map((sn) => {
                    const route = []
                    ;(bySn.get(sn) || []).forEach((transaction) => {
                        const warehouse = transaction.warehouse_name || '-'
                        const last = route[route.length - 1]
                        if (last && last.name === warehouse) {
                            last.goodIssue = last.goodIssue || transaction.transaction_type === 'GI'
                        } else {
                            route.push({ name: warehouse, goodIssue: transaction.transaction_type === 'GI' })
                        }
                    })
                    return { sn, route: route.map((item) => `${item.name}${item.goodIssue ? ' (Sudah Good Issue)' : ''}`).join(' → ') }
                })
                this.snNotFound = response.data.not_found || []
                this.snSearched = true
            } catch (error) {
                this.handleError(error)
            } finally {
                this.snLoading = false
            }
        },
        resetSn() {
            this.snInput = ''
            this.snRows = []
            this.snNotFound = []
            this.snSearched = false
            this.searchedSn = []
            this.snTxMap = {}
            this.snDetailSn = ''
            this.snDetailActive = false
        },
        openSnDetail(sn) {
            this.snDetailSn = sn
            this.snDetailActive = true
        },
        async exportMonitoringExcel() {
            this.snLoading = true
            try {
                const response = await this.$http.post(
                    'support/lacak-sn/monitoring-export-excel',
                    { sn: this.searchedSn, include_gi: true },
                    { responseType: 'blob' }
                )
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                FileSaver.saveAs(blob, `monitoring_lacak_sn_${Date.now()}.xlsx`)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.snLoading = false
            }
        },
        productDescription(product) {
            return [product && product.description_1, product && product.description_2]
                .map((value) => (value || '').trim())
                .filter(Boolean)
                .join(' - ')
        },
        formatQty(value) {
            if (value === null || value === undefined || value === '') {
                return value
            }

            return Number(value).toLocaleString('id-ID')
        },
        setLoading(isStart) {
            if (isStart) {
                this.loadingCount += 1
            } else {
                this.loadingCount = Math.max(0, this.loadingCount - 1)
            }
            this.isLoading = this.loadingCount > 0
        },
        applyFilters() {
            this.currentPage = 1
            this.fetchData()
        },
        getExportWarehouseName() {
            if (!this.warehouse_ids.length) {
                return 'All Warehouses'
            }

            if (this.warehouse_ids.length > 1) {
                return 'Multiple Warehouses'
            }

            const selectedWarehouse = this.warehouses.find(
                (warehouse) =>
                    String(warehouse.id) === String(this.warehouse_ids[0])
            )

            return selectedWarehouse
                ? selectedWarehouse.name
                : this.warehouse_ids[0]
        },
        resetFilters() {
            this.warehouse_ids.splice(0, this.warehouse_ids.length)
            this.start_date = ''
            this.end_date = ''
            this.currentPage = 1
            this.warehouseSelectKey += 1
            this.$nextTick(() => {
                if (this.$refs.warehouseSelect) {
                    this.$refs.warehouseSelect.clearSelection()
                }
            })
            this.fetchData()
        },
        async fetchData() {
            if (this.stockRequestInFlight) {
                return
            }
            this.stockRequestInFlight = true
            this.setLoading(true)
            try {
                const params = {
                    page: this.currentPage,
                    limit: this.limit,
                }

                if (this.warehouse_ids.length) {
                    params.warehouse_ids = this.warehouse_ids
                }

                if (this.start_date) {
                    params.start_date = this.start_date
                }

                if (this.end_date) {
                    params.end_date = this.end_date
                }

                const response = await this.$http.get(
                    '/tvd/monitoring/inventory',
                    { params }
                )

                this.tableData = response.data.data
                this.warehouses = response.data.warehouses
                this.totalPage = response.data.last_page
                this.lastUpdated = response.data.updated_at
                this.totalPerProduct = response.data.total_per_product || []
                this.stockLoadedPage = this.currentPage
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
                this.stockRequestInFlight = false
            }
        },
        async fetchMovement() {
            this.setLoading(true)
            try {
                const params = {}

                if (this.movementStartDate) {
                    params.start_date = this.movementStartDate
                }

                if (this.movementEndDate) {
                    params.end_date = this.movementEndDate
                }

                const productIds = this.movementSelectedProductIds()
                if (productIds.length) {
                    params.product_ids = productIds
                }

                const response = await this.$http.get(
                    '/tvd/monitoring/daily-movement',
                    { params }
                )

                this.movementData = response.data.data
                this.movementProducts = response.data.products || []
                this.movementTotalAccumulated = response.data.total_accumulated || []
                this.movementLoaded = true

            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
            }
        },
        async handleMovementExport() {
            this.isMovementExporting = true
            this.setLoading(true)

            try {
                const params = {}

                if (this.movementStartDate) {
                    params.start_date = this.movementStartDate
                }

                if (this.movementEndDate) {
                    params.end_date = this.movementEndDate
                }

                const productIds = this.movementSelectedProductIds()
                if (productIds.length) {
                    params.product_ids = productIds
                }

                const response = await this.$http.post(
                    '/tvd/monitoring/export-daily-movement',
                    params,
                    { responseType: 'blob' }
                )

                const dateStr = this.$moment().format('DDMMYYYY')
                FileSaver.saveAs(response.data, `Daily_Movement_${dateStr}.xlsx`)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.isMovementExporting = false
                this.setLoading(false)
            }
        },
        applyMovementFilter() {
            this.fetchMovement()
        },
        movementSelectedProductIds() {
            // products is an ordered code list; id = position (index + 1).
            if (!this.movementProductCodes.length || !this.movementProducts.length) {
                return []
            }
            return this.movementProductCodes
                .map((code) => this.movementProducts.indexOf(code) + 1)
                .filter((id) => id > 0)
        },
        resetMovementFilter() {
            this.movementProductCodes = []
            this.movementStartDate = ''
            this.movementEndDate = ''
            this.applyMovementFilter()
        },
        async refreshData() {
            this.setLoading(true)
            try {
                await this.$http.get('/tvd/monitoring/daily-base-qty')
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
                this.fetchData()
            }
        },
        async handleExport() {
            this.isExporting = true
            this.setLoading(true)

            try {
                const params = {}

                if (this.warehouse_ids.length) {
                    params.warehouse_ids = this.warehouse_ids
                }

                if (this.start_date) {
                    params.start_date = this.start_date
                }

                if (this.end_date) {
                    params.end_date = this.end_date
                }

                const response = await this.$http.post(
                    '/tvd/monitoring/export-excel',
                    params,
                    { responseType: 'blob' }
                )

                const warehouseName = this.getExportWarehouseName()

                const dateStr = this.$moment().format('DDMMYYYY')
                const filename = `Monitoring_${warehouseName}_${dateStr}.xlsx`

                FileSaver.saveAs(response.data, filename)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.isExporting = false
                this.setLoading(false)
            }
        },
        handleStockPageChange() {
            if (this.currentPage !== this.stockLoadedPage) {
                this.fetchData()
            }
        },
    },
}
</script>
